/* global module */

import '@swisslife/shared-ui/src/base/bootstrap/js/bootstrap';
import bootstrapApplication from '@swisslife/shared-ui/src/base/bootstrap/js/bootstrap';

// import basic js
import '@swisslife/shared-ui/src/base/security/js/security';

// import from pattern lib base
import '@swisslife/patterns-base/src/atoms/backdrop/js/backdrop';
import '@swisslife/patterns-base/src/atoms/checkbox/js/checkbox';
import '@swisslife/patterns-base/src/atoms/radio-button/js/radio-button';
import '@swisslife/patterns-base/src/atoms/animated-svg/js/animated-svg';
import '@swisslife/patterns-base/src/molecules/step-navigation/js/step-navigation';
import '@swisslife/patterns-base/src/molecules/links-downloads/js/links-downloads';
import '@swisslife/patterns-base/src/molecules/form-element/js/form-element';
import '@swisslife/patterns-base/src/molecules/file-upload/js/file-upload';
import '@swisslife/patterns-base/src/organisms/form/js/form';
import '@swisslife/patterns-base/src/organisms/overlay/js/overlay';

// import from pattern lib evolution
import '@swisslife/patterns-evolution/src/molecules/image-gallery/js/image-gallery';
import '@swisslife/patterns-evolution/src/molecules/mood-image/js/mood-image';
import '@swisslife/patterns-evolution/src/molecules/mood-image-conversion/js/mood-image-conversion';
import '@swisslife/patterns-evolution/src/molecules/quick-links/js/quick-links';
import '@swisslife/patterns-evolution/src/molecules/page-abstract/js/page-abstract';
import '@swisslife/patterns-evolution/src/molecules/segment-teaser/js/segment-teaser';
import '@swisslife/patterns-evolution/src/molecules/share/js/share';
import '@swisslife/patterns-evolution/src/molecules/distribution-teaser/js/distribution-teaser';
import '@swisslife/patterns-evolution/src/molecules/text-image/js/text-image';
import '@swisslife/patterns-evolution/src/molecules/call-to-action/js/call-to-action';
import '@swisslife/patterns-evolution/src/molecules/cookie-disclaimer/js/cookie-disclaimer';
import '@swisslife/patterns-evolution/src/molecules/elevator-pitch/js/elevator-pitch';
import '@swisslife/patterns-evolution/src/molecules/testimonial/js/testimonial';
import '@swisslife/patterns-evolution/src/molecules/product-comparison/js/product-comparison';
import '@swisslife/patterns-evolution/src/molecules/product-comparison-image/js/product-comparison-image';
import '@swisslife/patterns-evolution/src/molecules/table/js/table';
import '@swisslife/patterns-evolution/src/molecules/iframe/js/iframe';
import '@swisslife/patterns-evolution/src/molecules/listing/js/listing';
import '@swisslife/patterns-evolution/src/molecules/teaser-row/js/teaser-row';
import '@swisslife/patterns-evolution/src/molecules/purpose-hub-teaser/js/purpose-hub-teaser';
import '@swisslife/patterns-evolution/src/molecules/product-overview-teaser/js/product-overview-teaser';
import '@swisslife/patterns-evolution/src/molecules/language-navigation/js/language-navigation';
import '@swisslife/patterns-evolution/src/molecules/video-teaser/js/video-teaser';
import '@swisslife/patterns-evolution/src/molecules/info-box/js/info-box';
import '@swisslife/patterns-evolution/src/molecules/breadcrumb/js/breadcrumb';
import '@swisslife/patterns-evolution/src/molecules/favorite-link/js/favorite-link';
import '@swisslife/patterns-evolution/src/molecules/favorites-teaser/react/FavoritesTeaserRenderer';
import '@swisslife/patterns-evolution/src/molecules/news-date/js/news-date';
import '@swisslife/patterns-evolution/src/molecules/news-teaser/js/news-teaser';
import '@swisslife/patterns-evolution/src/molecules/hidden-url/js/hidden-url';
import '@swisslife/patterns-evolution/src/molecules/appointment-scheduler/js/appointment-scheduler';
import '@swisslife/patterns-evolution/src/molecules/content-image/js/content-image';
import '@swisslife/patterns-evolution/src/molecules/anchor-navigation/js/anchor-navigation';
import '@swisslife/patterns-evolution/src/molecules/contact-info/js/contact-info';
import '@swisslife/patterns-evolution/src/molecules/collapse-stepper/js/collapse-stepper';
import '@swisslife/patterns-evolution/src/molecules/tooltip/js/tooltip';
import '@swisslife/patterns-evolution/src/molecules/image-slider/js/image-slider';
import '@swisslife/patterns-evolution/src/molecules/immo-teaser/js/immo-teaser';
import '@swisslife/patterns-evolution/src/organisms/grid-row/js/grid-row';
import '@swisslife/patterns-evolution/src/organisms/header/js/header';
import '@swisslife/patterns-evolution/src/organisms/accordion/js/accordion';
import '@swisslife/patterns-evolution/src/organisms/fusion-widget/js/fusion-widget';
import '@swisslife/patterns-evolution/src/organisms/footer/js/footer';
import '@swisslife/patterns-evolution/src/organisms/overview-teaser/js/overview-teaser';
import '@swisslife/patterns-evolution/src/organisms/news-archive/js/news-archive';
import '@swisslife/patterns-evolution/src/organisms/filter/js/filter';
import '@swisslife/patterns-evolution/src/organisms/purpose-hub/js/purpose-hub';
import '@swisslife/patterns-evolution/src/organisms/video-hub/js/video-hub';
import '@swisslife/patterns-evolution/src/organisms/page/js/page';
import '@swisslife/patterns-evolution/src/organisms/search-result/js/search-result';
import '@swisslife/patterns-evolution/src/organisms/quiz/js/quiz';
import '@swisslife/patterns-evolution/src/organisms/onetrust-wrapper/js/onetrust-wrapper';

import './ui.styles';

if (module.hot) {
	module.hot.accept();
}

bootstrapApplication();

if (process.env.TARGET_ENV !== 'aem') {
	import(/* webpackChunkName: "fusion" */ './fusion');
}
